import iso3166 from 'iso-3166-2';

export const formatRegion = (regionCode) => {
  if (!regionCode) return null;
  const subdivision = iso3166.subdivision(regionCode);
  if (!subdivision) return regionCode;
  return `${subdivision.name}, ${subdivision.countryName}`;
};

export const formatCountry = (countryCode) => {
  if (!countryCode) return null;
  const country = iso3166.country(countryCode);
  if (!country) return countryCode;
  return country.name;
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'verified':
      return '#00c853';
    case 'mismatch':
      return '#ffeb3b';
    case 'unverified':
    default:
      return '#f44336';
  }
};
